import { useTranslation } from '@pypestream/translations';
import { humanizeLeaf, leafKey } from '@pypestream/ui-patterns';

/** A leaf's translated label; a leaf the backend adds before its copy reads as its own name. */
export function useLeafLabel(): (leaf: string) => string {
  const { t } = useTranslation();
  return (leaf) =>
    String(
      t(`manager/organizations:orgTabs.leaves.${leafKey(leaf)}`, {
        defaultValue: humanizeLeaf(leaf),
      })
    );
}
